import { z } from "zod";
import { SchemaTimeStampDB } from "@/schemas/Timestamp.schema";

const SchemaContactFields = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  indicatif: z.string(),
  telephone: z.string(),
  message: z.string(),
  engineId: z.number().optional().nullable(),
  offersIds: z.array(z.number()).optional().nullable(),
});

const SchemaContact = SchemaContactFields.extend({
  id: z.number(),
  emailSent: z.boolean(),
  emailSentAt: z.string().optional().nullable(),
  emailSentStatus: z.string().optional().nullable(),
  emailAccepted: z.array(z.string()),
  emailRejected: z.array(z.string()),
  emailMessageId: z.string().optional().nullable(),
  emailResponse: z.string().optional().nullable(),
  localizationId: z.string().optional().nullable(),
  latitude: z.number().optional().nullable(),
  longitude: z.number().optional().nullable(),
  localizationIdCreatedAt: z.string().optional().nullable(),
}).merge(SchemaTimeStampDB);

const SchemaContacts = z.array(SchemaContact);

const SchemaContactCreate = z.object({
  firstName: z.string().min(1, "Le prénom est requis"),
  lastName: z.string().min(1, "Le nom est requis"),
  email: z.string().email("Adresse email invalide"),
  indicatif: z.enum(["+33", "+596"], {
    required_error: "L'indicatif est obligatoire.",
  }),
  telephone: z
    .string()
    .length(9, { message: "Le numéro de téléphone doit comporter exactement 9 chiffres." }),
  message: z.string().min(10, "Le message doit comporter au moins 10 caractères"),
  engineId: z.number().optional().nullable(),
  offersIds: z.array(z.number()).optional().nullable(),
  localizationId: z.string().optional().nullable(),
  latitude: z.number().optional().nullable(),
  longitude: z.number().optional().nullable(),
  localizationIdCreatedAt: z.string().optional().nullable(),
});

export { SchemaContact, SchemaContacts, SchemaContactCreate };
